import type { Sender } from 'xstate';

import { ToastType } from 'src/shared/components/Toast/types';

import type { Event } from './types';

const offlineToast = (callback: Sender<Event>, message: string) => {
  if (!window?.navigator.onLine) {
    callback({
      type: 'SHOW_ERROR',
      data: {
        message,
        type: ToastType.PASSIVE,
        isOnline: window?.navigator?.onLine,
      },
    });
  }
};
export { offlineToast };
